import { connect } from 'react-redux';
import React from 'react';
import OwnerMintCoins from './OwnerMintCoins';
import OwnerCreateCoupon from './OwnerCreateCoupon';
import AddressRefrigerator from './AddressRefrigerator';
import OwnerEnableAddress from './OwnerEnableAddress';
import OwnerDisableAddress from './OwnerDisableAddress';
import OwnerEnableBuyingCoinForAddress from './OwnerEnableBuyingCoinsForAddress';
import OwnerDisableBuyingCoinsForAddress from './OwnerDisableBuyingCoinsForAddress';
import AddressCanBuyCoinsRefrigerator from './AddressCanBuyCoinsRefrigerator';

const mapStateToProps = state => {
  return {
    isContractOwner: state.account.isContractOwner
  };
};

const connectedOwnerDashboard = ({isContractOwner}) => {
  if (!isContractOwner) {
    return null;
  }

  return (
    <React.Fragment>
      <h1>Owner dashboard</h1>
      <div className="c-components">
        <OwnerMintCoins/>
        <OwnerCreateCoupon/>
        <OwnerDisableAddress/>
        <OwnerEnableAddress/>
        <AddressRefrigerator/>
        <OwnerEnableBuyingCoinForAddress/>
        <OwnerDisableBuyingCoinsForAddress/>
        <AddressCanBuyCoinsRefrigerator/>
      </div>
    </React.Fragment>
  );
};

const OwnerDashboard = connect(mapStateToProps)(connectedOwnerDashboard);

export default OwnerDashboard;


// WEBPACK FOOTER //
// ./src/components/OwnerDashboardPage/OwnerDashboard.js